import React, { useContext } from 'react';
import { Button } from 'baseui/button';

import { ModalContext } from 'commons-ui';

import { PAGE_NAMES, USER_PROFILE_RESOURCES, USER_PROFILE_ACL_ACTIONS } from 'constant';
import usePermission from 'commons-ui/src/permission/usePermission';
import UserSupportCall from './UserSupportCall';

const makeUserSupportCall = () => {
	const { setModalConfig } = useContext(ModalContext);
	const { hasPermission } = usePermission();

	const handleUserSupportCall = async () => {
		setModalConfig({
			isOpen: true,
			header: 'Call User Support',
			content: <UserSupportCall />
		});
	};

	return hasPermission({
		configPageName: PAGE_NAMES.userProfile,
		configResourceName: USER_PROFILE_RESOURCES.previousTickets,
		configActionName: USER_PROFILE_ACL_ACTIONS.callUser
	}) ? (
		<Button onClick={handleUserSupportCall} size='compact'>
			Call User Support
		</Button>
	) : (
		<> </>
	);
};

export default makeUserSupportCall;
